{
  "name": "groups",
  "version": "2.19.0",
  "engines": {
    "node": ">=22.13.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && npm run sentry:sourcemaps",
    "vercel-build": "node scripts/write-config.mjs && npm run build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "e2e": "ng e2e",
    "lint": "ng lint",
    "version:start": "bash ./scripts/version_start.sh",
    "version:bump": "bash ./scripts/version_bump.sh",
    "version:end": "bash ./scripts/version_end.sh",
    "hotfix": "bash ./scripts/hotfix.sh",
    "changelog": "conventional-changelog -p angular -i CHANGELOG.md -s",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org sentry --project groups2 ./dist && sentry-cli --url https://sentry.moveo.technology/ sourcemaps upload --org sentry --project groups2 ./dist",
    "lint-staged": "lint-staged"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^22.1.6",
    "@angular/cdk": "^22.1.6",
    "@angular/common": "^22.1.6",
    "@angular/compiler": "^22.1.6",
    "@angular/core": "^22.1.6",
    "@angular/forms": "^22.1.6",
    "@angular/google-maps": "^22.1.6",
    "@angular/material": "^22.1.6",
    "@angular/material-date-fns-adapter": "^22.1.6",
    "@angular/platform-browser": "^22.1.6",
    "@angular/platform-browser-dynamic": "^22.1.6",
    "@angular/router": "^22.1.6",
    "@angular/service-worker": "^22.1.6",
    "@sentry/angular": "^10.74.0",
    "@sentry/cli": "^2.45.0",
    "@stripe/stripe-js": "^9.16.0",
    "@tailwindcss/postcss": "^4.0.6",
    "date-fns": "^4.1.0",
    "google-libphonenumber": "^3.2.40",
    "highcharts": "^12.2.0",
    "ngx-countup": "^13.2.0",
    "ngx-quill": "^31.0.1",
    "ngx-stripe": "^22.9.0",
    "postcss": "^8.5.10",
    "pusher-js": "^8.4.0",
    "rxjs": "~7.8.0",
    "tailwindcss": "^4.0.6",
    "tslib": "^2.3.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^22.1.8",
    "@angular/build": "^22.1.8",
    "@angular/cli": "^22.1.8",
    "@angular/compiler-cli": "^22.1.6",
    "@eslint/eslintrc": "^3.2.0",
    "@eslint/js": "^9.19.0",
    "@playwright/test": "^1.51.0",
    "@types/google-libphonenumber": "^7.4.30",
    "@types/google.maps": "^3.58.1",
    "@types/jasmine": "~5.1.0",
    "conventional-changelog": "^7.0.2",
    "conventional-changelog-angular": "^8.0.0",
    "dotenv": "^16.4.7",
    "eslint": "^9.16.0",
    "eslint-config-prettier": "^10.0.1",
    "eslint-plugin-prettier": "^5.2.2",
    "husky": "^9.1.7",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "lint-staged": "^15.5.2",
    "playwright-ng-schematics": "^1.2.2",
    "postcss": "^8.5.10",
    "prettier": "^3.4.2",
    "prettier-eslint": "^17.1.1",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.57.0",
    "angular-eslint": "22.5.0"
  },
  "overrides": {
    "@angular-devkit/build-angular": {
      "tailwindcss": "^4.0.0"
    },
    "ajv@8": "8.18.0",
    "picomatch@4": "4.0.4",
    "sockjs": {
      "uuid": "^11.1.1"
    }
  }
}
